import { CircularProgress, Typography, Box } from "@mui/material";

const Loading = ({ message  }) => {
    return (
      <div align="center">
       <CircularProgress color="primary" size={50} thickness={4} />
      <Typography variant="h4" sx={{ mt: 2, color: "gray" }}>
        {message}
      </Typography>
      </div>
    );
  };
  
  export default Loading;